import * as actions from './actions';

const initialState = {
    contacts: [],
    error: null,
    initial: false,
    loading: false,
};

export default function brevoContactsReducer(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_BREVO_CONTACTS.REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_BREVO_CONTACTS.SUCCESS:
            return { ...state, initial: true, contacts: action.payload.data, loading: false, error: null };

        case actions.FETCH_BREVO_CONTACTS.FAILURE:
            return { ...state, initial: false, loading: false, error: action.payload.error };

        default:
            return state;
    }
}